import React from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import api from "../services/Api";
 
export function SelectApi({textFieldProps, ...props}) {
  const { error, helperText, disabled, getOptionDisabled, config, options: staticOptions, nullMessage, ...field } = props;
  const { onChange, id, name, value, multiple, limitTags} = field
  
  const [filter, setFilter] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState(staticOptions || []);
 
  const loading = open && options.length === 0 && config;

  React.useEffect(() => {
    let active = true;
    if (!loading) {return undefined}

    (async () => {
      const response = await api(config)
      const {data} = response;

      if (data.length === 0 || data === null) return setOptions([{id: null, name:`${nullMessage}`}]) 
      if (active && data !== null) setOptions(data)
    })();

    return () => {active = false};
  }, [loading, config]);//filter

  React.useEffect(() => {
    if (!open) {
      if (!staticOptions) {
        setOptions([]);
      }
    }
  }, [open, staticOptions]);

  React.useEffect(() => {
    if (staticOptions) {
      setOptions(staticOptions);
    }
  }, [staticOptions]);

  return (
    <Autocomplete
    onChange={onChange}
    value={value}
    id={id}
    name={name}
    open={open}
    disabled={disabled}
    getOptionDisabled={getOptionDisabled}
    multiple={multiple}
    limitTags={limitTags}
    onOpen={() => setOpen(true)}
    onClose={() => setOpen(false)}
    inputValue={filter}
    onInputChange={(event, newInputValue) => setFilter(newInputValue)}
    getOptionSelected={(option, value) => option.id === value.id}
    getOptionLabel={(option) => option.name ? option.name : option.description ? option.description : option.tipo ? option.tipo : ''}
    options={options}
    loading={loading}
    loadingText='Carregando...'
    noOptionsText="Sem opções"
    clearText="Limpar"
    openText="Abrir"
    closeText="Fechar"
    autoHighlight
    uncontrolled="true"
    renderInput={(params) => (
      <TextField
        {...params}
        {...textFieldProps}
        helperText={helperText}
        error={error}
        InputProps={{
          ...params.InputProps,
          autoComplete: 'off',
          endAdornment: (
            <React.Fragment>
              {loading ? (
                <CircularProgress color="inherit" size={20} />
              ) : null}
              {params.InputProps.endAdornment}
            </React.Fragment>
          ),
        }}
 
      />
    )}
  />
);
}

SelectApi.defaultProps = {
  nullMessage: "Sem opções",
  textFieldProps:{
    fullWidth: true,
    size: "small",
    margin: "normal",
    variant: "outlined",
  }
 
}